<template>
  <main class="projects" v-if="projects.length > 0">
    <section class="filter">
      <router-link :to="{ name: 'projects', hash: '' }">All</router-link>
      <router-link :to="{ name: 'projects', hash: '#furniture' }"
        >Furniture</router-link
      >
      <router-link :to="{ name: 'projects', hash: '#lighting' }"
        >Lighting</router-link
      >
      <router-link :to="{ name: 'projects', hash: '#product' }"
        >Products</router-link
      >
      <router-link :to="{ name: 'projects', hash: '#interior' }"
        >Interior</router-link
      >
    </section>
    <section class="projects" v-if="projects.length > 0">
      <router-link
        v-for="project in projects"
        :key="project.uid"
        :to="{ name: 'project', params: { id: project.uid } }"
      >
        <div :class="project.files.orientation">
          <p class="title caption uppercase">
            {{ project.title
            }}<span class="hide">
              ({{ project.year }}) {{ project.category }} ↑</span
            >
          </p>
          <img v-lazy="project.files.small" :alt="project.title" />
          <img class="loader" :src="project.files.thumb" :alt="project.title" />
        </div>
      </router-link>
    </section>
    <section v-else class="col-2">
      No projects available in this category
    </section>
  </main>
</template>

<script>
export default {
  name: "projects",
  metaInfo: {
    title: "- Projects"
  },
  computed: {
    projects() {
      var hash = this.$route.hash.split("#")[1];
      let projects = this.$store.state.projects;
      if (!hash) {
        return projects;
      } else {
        let filtered = projects.filter(project => {
          return project.category == hash;
        });
        return filtered;
      }
    }
  }
};
</script>

<style lang="scss">
.filter {
  padding: 0 calc(2 * var(--lh));
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  a {
    padding-right: var(--lh);
    color: #aaa;
    text-transform: uppercase;
    font-size: calc(0.8 * var(--fs));
    line-height: 1.1;
    letter-spacing: 0.025rem;
    cursor: pointer;
    transition: color 0.5s;
    @media only screen and (max-width: 768px) {
      flex: 0 0 100%;
    }
    &.router-link-exact-active {
      color: black;
    }
  }
}
.projects {
  padding: calc(2 * var(--lh));
  margin: 0 0 calc(2 * var(--lh)) 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  a {
    flex: 0 0 auto;
    padding: calc(0.5 * var(--lh));
    max-width: 100%;
    display: inline-block;
    .hide {
      opacity: 0;
      transition: opacity 0.5s;
    }
    &:hover {
      color: black;
      .hide {
        opacity: 1;
      }
    }
    div {
      position: relative;
      max-width: 100%;
      overflow: hidden;
      img {
        height: 60vh;
        width: 100%;
        max-width: 100%;
        object-fit: cover !important;
        transition: opacity 0.5s;

        @media only screen and (max-width: 1024px) {
          height: 50vh;
        }
        @media only screen and (max-width: 768px) {
          height: auto;
        }

        &[lazy="loading"] {
          opacity: 0;
        }
        &[lazy="loaded"] {
          opacity: 1;
          ~ img.loader {
            transition: opacity 0.5s 0.2s;
            opacity: 0;
          }
        }
        &.loader {
          position: absolute;
          width: 100%;
          filter: blur(10px);
          object-fit: cover !important;
          top: 0;
          left: 0;
        }
      }
      &.portrait {
        width: calc((4 / 5) * 60vh);
        @media only screen and (max-width: 1024px) {
          width: calc((4 / 5) * 50vh);
        }
        @media only screen and (max-width: 768px) {
          width: 100%;
        }
      }
      &.landscape {
        width: calc((3 / 2) * 60vh);
        @media only screen and (max-width: 1024px) {
          width: calc((3 / 2) * 50vh);
        }
        @media only screen and (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }
}
</style>
